import React, { useEffect, useState } from "react";

import {
  TableRow,
  TableCell,
  Paper,
  Grid,
  TableContainer,
  Table,
  TableBody,
} from "@material-ui/core";

import { stableSort, getComparator } from "App/Component/ui/datatable/utils";

import {
  TableAction,
  TableHeader,
  InputOptionMaster,
  DatatablesFooterServerSide,
  Loading,
} from "App/Component/ui";

import {
  useDatatables,
  useDatatablesServerSide,
  useSelectOption,
} from "App/hooks";
import {
  headCells,
  // RESET_STATE_FORM_FILTER,
  RESET_STATE_MASTER_FORMULA_HARGA,
  getByFilterFormulaHarga,
} from "./helpers";
import { isNull, scrollToTop, defaultToastError } from "App/utils/helpers";
import { STYLE_DEFAULT_MASTER, TYPE_INSTANCE4 } from "App/constants";
import FormMasterFormulaHarga from "./FormMasterFormulaHarga";
import { useTarifAsHeadCells } from "hooks";
import { LIST_URL_WAREHOUSE } from "utils/warehouse";

export default function MasterFormulaHarga() {
  const [formData, setFormData] = useState(RESET_STATE_MASTER_FORMULA_HARGA);
  const { newHeadCells, headTarif } = useTarifAsHeadCells(headCells);

  function clickUpdate(row) {
    setFormData({
      id: row?.harga_id,
      harga_id: row?.harga_id,
      formula_id: row?.formula_id,
      namaMsHarga: row?.namaMsHarga,
      namaFormula: row?.namaFormula,
      jenisTarif: row?.jenisTarif,
    });
    scrollToTop();
  }

  const classes = STYLE_DEFAULT_MASTER();

  const [jenisHargaID, setJenisHargaID] = useState({
    value: null,
    label: "Pilih Jenis Harga",
  });

  const jenisHarga = useSelectOption(
    true,
    LIST_URL_WAREHOUSE.masterHarga.get,
    TYPE_INSTANCE4,
    "id",
    "name",
    "data"
  );

  const [rows, setRows] = useState([]);
  const [totalData, setTotalData] = useState(0);
  const [loading, setLoading] = useState(false);

  const { order, orderBy, handleRequestSort, length } = useDatatables({
    rows: rows,
    orderByDefault: "harga_id",
    orderByRow: ["harga_id", "namaFormula"],
  });

  useEffect(() => {
    (async () => {
      await setNewData();
    })();
  }, [jenisHargaID.value]); // eslint-disable-line react-hooks/exhaustive-deps

  const setNewData = async (pages = 1, limit = 10) => {
    setLoading(true);

    const res = await getByFilterFormulaHarga(
      jenisHargaID.value,
      pages,
      limit,
      headTarif.length
    );
    if (res.state) {
      setRows(res.data);
      setTotalData(res.meta.count);
      setLoading(false);
    } else {
      setRows([]);
      setLoading(false);
      defaultToastError(res.message);
    }
  };

  const {
    pagination,
    onNext,
    onPrevious,
    handleClickPageNumber,
    handleChangeLimit,
  } = useDatatablesServerSide({ setNewData: setNewData });

  return (
    <>
      <Paper className={classes.paper}>
        <FormMasterFormulaHarga
          formData={formData}
          setFormData={setFormData}
          setNewData={setNewData}
        />
      </Paper>

      <div className='mt-2'>
        <Grid
          container
          spacing={1}
          style={{
            marginBottom: "1rem",
          }}>
          <Grid item sm={4}>
            <InputOptionMaster
              name='jenis_harga_id'
              label='JENIS HARGA'
              id='jenis_harga_id'
              value={jenisHargaID.value}
              labelValue={jenisHargaID.label}
              withSearch={true}
              onChange={(e) => {
                if (isNull(e)) {
                  setJenisHargaID({
                    value: null,
                    label: "Pilih Jenis Harga",
                  });
                } else {
                  setJenisHargaID({
                    value: e.value,
                    label: e.label,
                  });
                }
              }}
              data={jenisHarga}
            />
          </Grid>
        </Grid>
        <Paper className={classes.paper}>
          <Loading show={loading} />
          <TableContainer className='custom-scrollbar'>
            <Table
              className={classes.table}
              aria-labelledby='tableTitle'
              size={"medium"}
              aria-label='enhanced table'>
              <TableHeader
                classes={classes}
                order={order}
                orderBy={orderBy}
                onRequestSort={handleRequestSort}
                rowCount={length}
                headCells={newHeadCells}
              />
              <TableBody>
                {stableSort(rows, getComparator(order, orderBy)).map(
                  (row, index) => {
                    return (
                      <>
                        <TableRow
                          hover
                          tabIndex={-1}
                          key={index}
                          style={{
                            backgroundColor:
                              index % 2 === 0 ? "transparent" : "#fff",
                          }}>
                          <TableCell
                            component='th'
                            scope='row'
                            padding='none'
                            align='center'>
                            {index + 1}
                          </TableCell>

                          <TableCell
                            component='th'
                            scope='row'
                            padding='none'
                            align='center'>
                            <TableAction
                              isDelete={false}
                              clickUpdate={() => clickUpdate(row)}
                            />
                          </TableCell>

                          <TableCell align='left'>{row?.namaFormula}</TableCell>
                          <TableCell align='left'>{row?.namaMsHarga}</TableCell>
                          {row.jenisTarif.map((item) => {
                            if (!isNull(item.namaTarif)) {
                              return (
                                <>
                                  <TableCell align='left'>
                                    {item.persentasi}
                                  </TableCell>
                                </>
                              );
                            } else {
                              return <></>;
                            }
                          })}
                        </TableRow>
                      </>
                    );
                  }
                )}
              </TableBody>
            </Table>
          </TableContainer>
          <DatatablesFooterServerSide
            totalData={totalData}
            pagination={pagination}
            handleChangeLimit={handleChangeLimit}
            onPrevious={onPrevious}
            onNext={onNext}
            currentPage={pagination.page}
            handleClickPageNumber={handleClickPageNumber}
          />
        </Paper>
      </div>
    </>
  );
}
